import { jsx as _jsx } from "react/jsx-runtime";
import clamp from '@/utils/clamp';
import { twMerge } from 'tailwind-merge';
import { emphasiseText } from '../../../helpers/emphasiseText';
const FullWidthHeading = ({ children, className, ...otherProps }) => {
    // Calculate true heading length without emphasis characters.
    // Cap at 14 characters, headings longer than this will wrap.
    const actualLength = Math.min(children.replace('##', '').length, 14);
    // Longer headings are more likely to even out, be cautious with shorter headings
    const scaleFactor = Math.min(1.45 + actualLength * 0.0025, 1.7);
    // Minimum size is based on expressive large.
    const midSize = `${(100 / actualLength) * scaleFactor}cqw`;
    const minSize = clamp(56, 100);
    const maxSize = clamp(72, 200);
    return (_jsx("span", { ...otherProps, className: twMerge('@container', className), children: _jsx("span", { className: "type-masthead", style: {
                fontSize: `clamp(var(--minSize), var(--midSize), var(--maxSize))`,
                '--midSize': midSize,
                '--minSize': minSize,
                '--maxSize': maxSize,
            }, children: emphasiseText(children) }) }));
};
export default FullWidthHeading;
